export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN
export const SENTRY_SAMPLE_RATE = process.env.REACT_APP_SENTRY_SAMPLE_RATE || 1.0
